/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolTourIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-tour"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M7.3 14.3L7.3 21.18Q7.3 21.73 6.91 22.11Q6.53 22.5 5.97 22.5Q5.42 22.5 5.04 22.11Q4.65 21.73 4.65 21.18L4.65 2.77Q4.65 2.23 5.04 1.84Q5.42 1.45 5.97 1.45Q6.53 1.45 6.91 1.84Q7.3 2.23 7.3 2.77L7.3 3.5L19.75 3.5Q20.45 3.5 20.85 4.09Q21.25 4.67 20.98 5.33L19.55 8.9L20.98 12.47Q21.25 13.13 20.85 13.71Q20.45 14.3 19.75 14.3ZM12.6 11.25Q12.6 11.25 13.09 11.25Q13.57 11.25 14.26 10.56Q14.95 9.88 14.95 8.9Q14.95 7.92 14.26 7.24Q13.57 6.55 12.6 6.55Q11.63 6.55 10.94 7.24Q10.25 7.92 10.25 8.9Q10.25 9.88 10.94 10.56Q11.63 11.25 12.6 11.25Z" fill={color} />
    </svg>
  );
}
